import React from 'react';
import { Typography } from '@mui/material';

/**
 * Amount template with currency formatting
 */
export const AmountTemplate: React.FC<{ amount?: number }> = ({ amount }) => (
  <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 500 }}>
    ${(amount ?? 0).toFixed(2)}
  </Typography>
);

export default AmountTemplate;
